'use client';

import * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { cn } from '../../lib/utils';

interface CheckboxProps extends Omit<React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>, 'onCheckedChange'> {
    onCheckedChange?: (checked: boolean) => void;
}

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
    ({ className, onCheckedChange, ...props }, ref) => (
        <CheckboxPrimitive.Root
            ref={ref}
            className={cn(
                // DS3 Checkbox: a 2px stroke box that fills solid when checked.
                'peer flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-x10 border-2 border-solid border-stroke-x20 transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-x20 focus-visible:ring-offset-1',
                'disabled:cursor-not-allowed disabled:opacity-30',
                'data-[state=checked]:border-transparent data-[state=checked]:bg-container-x10 data-[state=checked]:text-surface-x10',
                className,
            )}
            onCheckedChange={(checked) => onCheckedChange?.(checked === true)}
            {...props}
        >
            <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
                {/* DS3's check mark. */}
                <svg viewBox="0 0 18 18" className="h-3.5 w-3.5" fill="none" aria-hidden="true">
                    <path d="M2 8.5L6.5 13L17 3" stroke="currentColor" strokeWidth={2.5} />
                </svg>
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    ),
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
